import { RevisaoSeloFiltroSgsia } from './../../../model/sgsia/revisao-selo-filtro-sgsia';
import { RespostaPaginada } from './../../../model/sgsia/paginacao-sgsia';
import { RevisaoSeloSgsia } from './../../../model/sgsia/revisao-selo-sgsia';
import { map, catchError } from 'rxjs/operators';
import { from, Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { WSO2ClientAppBase } from '../../wso2-client-app-base.service';

@Injectable({
  providedIn: 'root'
})

export class RevisaoSeloService extends WSO2ClientAppBase {

    save(data: any): Observable<any>{
        return this.getClient().post('/api/v1/revisao', data).pipe(
            catchError(this.handleError)
        );
    }

    emRevisao(idSolicitacao: (number | string)): Observable<boolean> {
        return this.getClient().get(`/api/v1/revisao/consultar-em-andamento/solicitacao/${idSolicitacao}`).pipe(
            map((item: any) => {
                return item.conteudo;
            }),
            catchError(this.handleError)
        );
    }

    getById(idRevisao: (number | string)): Observable<RevisaoSeloSgsia> {
        return this.getClient().get(`/api/v1/revisao/${idRevisao}`).pipe(
            map((item: any) => {
                return this.jsonDataToResource(item.conteudo);
            }),
            catchError(this.handleError)
        );
    }

    getRevisaoEmAndamentoByIdSolicitacao(idSolicitacao: (number | string)): Observable<RevisaoSeloSgsia> {
        return this.getClient().get(`/api/v1/revisao/em-andamento/solicitacao/${idSolicitacao}`).pipe(
            map((item: any) => {
                return this.jsonDataToResource(item.conteudo);
            }),
            catchError(this.handleError)
        );
    }

    getByIdSolicitacao(idSolicitacao: (number | string)): Observable<Array<RevisaoSeloSgsia>> {
        return this.getClient().get(`/api/v1/revisao/solicitacao/${idSolicitacao}`).pipe(
            map((item: any) => {
                return this.jsonDataToResources(item.conteudo);
            }),
            catchError(this.handleError)
        );
    }

    revisar(id: any, data: any): Observable<any>{
        return this.getClient().put(`/api/v1/revisao/revisar/${id}`, data).pipe(
            catchError(this.handleError)
        );
    }


    revisaranalisarSuspensao(id: any, data: any): Observable<any>{
        return this.getClient().put(`/api/v1/revisao/revisar-suspensao/${id}`, data).pipe(
            catchError(this.handleError)
        );
    }


    aprovar(id: any, aprovado: any): Observable<any>{
        return this.getClient().put(`/api/v1/revisao/${id}/aprovar-revisao?aprovado=${aprovado}`, undefined).pipe(
            catchError(this.handleError)
        );
    }

    consultar(filtro: RevisaoSeloFiltroSgsia): Observable<RespostaPaginada<RevisaoSeloSgsia>> {
        const solicitacaoPromise = this.getClient()
            .get(`/api/v1/revisao`, filtro.getAsHTTPParams() || null);
        return from(solicitacaoPromise).pipe(
            map((item: any) => {
                item.conteudo = this.jsonDataToResources(item.conteudo);
                return item;
            }),
            catchError(this.handleError)
        );
    }

    jsonDataToResources(jsonData: Array<any>): Array<RevisaoSeloSgsia> {
        const data = jsonData || [];
        return data.map((item: any) => RevisaoSeloSgsia.fromJson(item));
    }

    jsonDataToResource(jsonData: any): RevisaoSeloSgsia {
        return RevisaoSeloSgsia.fromJson(jsonData);
    }

    /**
     * Exibe mensagem no console
     */
    protected handleError(error: any): Observable<any>{
        console.log('ERROR NA REQUISIÇÃO => ', error);
        return throwError(error);
    }
}
